import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202506: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202506",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-06-01",
  endDate: "2025-06-30",
  impressions: 7213,
  clicks: 115,
  adsSpendDollars: 201,
  budgetDollars: 600,
  salesDollars: 1035,
  bestEstimateRoas: 5.15,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.34,
  reorderConversions: 5,
  dataAvailableAtDate: "2025-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
